/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * API
 * Audius V1 API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { User } from './User';
import {
    UserFromJSON,
    UserFromJSONTyped,
    UserToJSON,
} from './User';

/**
 * 
 * @export
 * @interface SubscribersResponse
 */
export interface SubscribersResponse {
    /**
     * 
     * @type {Array<User>}
     * @memberof SubscribersResponse
     */
    data?: Array<User>;
}

/**
 * Check if a given object implements the SubscribersResponse interface.
 */
export function instanceOfSubscribersResponse(value: object): value is SubscribersResponse {
    let isInstance = true;

    return isInstance;
}

export function SubscribersResponseFromJSON(json: any): SubscribersResponse {
    return SubscribersResponseFromJSONTyped(json, false);
}

export function SubscribersResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscribersResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(UserFromJSON)),
    };
}

export function SubscribersResponseToJSON(value?: SubscribersResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(UserToJSON)),
    };
}

